<template>
    <!-- 圆角弹窗（底部） -->
    <van-popup
        class="ProductPreviewCom"
        v-model:show="previewShow"
        round
        closeable
        position="bottom"
        @close="onClose"
        @click="onClose"
        v-if="product"
    >
        <div class="main-container">
            <div class="thumbnail-container">
                <van-image
                    class="thumbnail"
                    draggable="false"
                    fit="scale-down"
                    :src="product.thumbnail"
                />
            </div>
            <p style="font-weight: 900; color: #555; margin: 8px 0;">{{ product.title }}</p>
            <p style="font-weight: 900; color: #AAA; margin: 8px 0;">{{ product.title_cn }}</p>
            <van-row>
                <van-col :span="10" style="text-align: left; padding-left: 24px;">
                    <van-tag color="#ffe1e1" text-color="#ad0000" style="font-weight: 800; font-size: 15px; padding: 4px 12px;" v-if="product.category_id">{{ getCategoryName(product.category_id) }}</van-tag>
                </van-col>
                <van-col :span="14" style="text-align: right; padding-right: 24px;">
                    <DiscountTagCom style="margin-right: 4px;">
                    </DiscountTagCom>
                    <span style="font-weight: 900; color: blue; margin: 0 0; font-size: 20px;">
                        $ {{  display_currency(product.retail) }}
                    </span>
                </van-col>
            </van-row>
            <van-divider
                :style="{ color: '#AAA', borderColor: '#AAA', padding: '0 2px', margin  : '2px 0' }"
            >
                Description
            </van-divider>
            <p style="color: purple; margin: 2px 0; padding: 0 12px;" v-if="product.short_desc">{{  product.short_desc }}</p>
            <p style="color: #888; margin: 2px 0; padding: 0 12px;" v-if="product.desc">{{ product.desc}}</p>
            <van-empty description="" v-if="!product.short_desc && !product.desc" style="margin: 2px 0; padding: 0 0" />
        </div>
        <div class="button-container">
            <van-button
                block
                type="primary"
                @click.stop="onAddToCart"
                class="button"
                v-if="getProductStock(product) > 0"
            >
                {{ t("common.button.addCart") }}
            </van-button>
            <van-button
                block
                type="primary"
                disabled
                @click.stop="onOutOfStock"
                class="button"
                style="color: red; background-color: white; border-color: red;"
                v-else
            >
                {{ t("common.noti.outOfStock") }}
            </van-button>
        </div>
    </van-popup>
</template>
<script setup>
import i18n from "@/i18n"
import { showNotify } from "vant"
import { display_currency } from "megautils-js"
import { ref, defineProps, reactive, computed, onMounted } from "vue"
import { useStore } from "vuex"
import { FetchProductByCategoryService } from "@/services/h5/h5ProductService"
import { getProductStock } from "@/utils/productUtils"
import DiscountTagCom from "../DiscountTagCom/DiscountTagCom.vue"


// MARK - Props
// ************************************************************************
const { t } = i18n.global
const store = useStore()
const previewShow = computed({
    get: () => {
        console.log(product.value)
        return store.getters.getPreviewShow
    },
    set: (value) => {
        store.commit("setPreviewProduct", null)
    },
})
const product = computed(() => store.getters.getPreviewProduct)
const categoryData = reactive([])
const isLoading = ref(false)

// MARK - LIFE CYCLE
// ************************************************************************
onMounted(() => {
    loadData()
})

// MARK - Methods
// ************************************************************************
const getCategoryName = (category_id) => {
    for (let i = 0; i < categoryData.length; i++) {
        if (categoryData[i].id == category_id) {
            return categoryData[i].category_name
        }
    }
    return ""
}

const onAddToCart = () => {
    store.commit("addProductToCart", Object.assign({}, store.getters.getPreviewProduct))
    isLoading.value = true
    setTimeout(() => {
        isLoading.value = false
        store.commit("setPreviewProduct", null)
    }, 200);
    showNotify({
        type: "success",
        message: t("common.noti.addCartSuccess"),
        duration: 500,
    })
}

const onOutOfStock = () => {
}

const onClose = () => {
    store.commit("setPreviewProduct", null)
}

const loadData = () => {
    FetchProductByCategoryService().then((res) => {
        categoryData.splice(0, categoryData.length)
        categoryData.push(...res.data)
    }).catch((err) => {
    })
}
</script>
<style>
.ProductPreviewCom {
    width: 100%;
    height: 80vh;
    display: flex;
    flex-direction: column;
    z-index: 100000;
}

.ProductPreviewCom .main-container {
    flex: 1; /* 占据剩余空间，保持按钮在底部 */
}

.ProductPreviewCom .button-container {
    margin-top: auto; /* 使按钮推到页面底部 */
    margin-bottom: 16px;
}

.ProductPreviewCom .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.ProductPreviewCom .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
}

.ProductPreviewCom .thumbnail-container {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    max-height: 40vh;
    overflow: hidden;
}

.ProductPreviewCom .van-empty__image {
    width: 30%;
    height: 30%;
}

.ProductPreviewCom .button {
    width: 95%;
    margin-left: 2.5%;
    font-weight: 800;
    border-radius: 24px;
}

</style>
